exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-6ad69c2b] .flickity-prev-next-button {\n  width: 22px;\n  height: 22px;\n}\n[data-v-6ad69c2b] .flickity-viewport {\n  overflow: hidden !important;\n  margin-left: 0.5rem !important;\n  margin-right: 0.5rem !important;\n}\n[data-v-6ad69c2b] .flickity-prev-next-button.next {\n  right: -20px;\n}\n[data-v-6ad69c2b] .flickity-prev-next-button.previous {\n  left: -20px;\n}\n.cell[data-v-6ad69c2b] {\n  display: none;\n}\n.flickity-viewport .cell[data-v-6ad69c2b] {\n  display: flex;\n}\n", ""]);

// exports
